import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import Button from '@Components/Button';

function HeatmapSettingsDialogFooter({ disabled, alwaysShowSettings, setAlwaysShowSettings, applySettings }) {
  return (
    <div className="heatmap-settings-dialog__footer">
      <Checkbox
        label="Always show settings"
        onChange={setAlwaysShowSettings}
        checked={alwaysShowSettings}
        className="heatmap-settings-dialog__checkbox"
      />
      <Button
        buttonConfig={{
          type: 'primary',
          size: 'sm',
          label: 'Apply',
          e2eName: 'heatmap-settings-apply',
        }}
        iconConfig={{
          name: 'chevron-right',
          size: 'sm',
        }}
        disabled={disabled}
        onClick={applySettings}
      />
    </div>
  );
}

HeatmapSettingsDialogFooter.defaultProps = {
  setAlwaysShowSettings: () => {},
  applySettings: () => {},
};

HeatmapSettingsDialogFooter.propTypes = {
  disabled: PropTypes.bool,
  alwaysShowSettings: PropTypes.bool,
  setAlwaysShowSettings: PropTypes.func,
  applySettings: PropTypes.func,
};

export default HeatmapSettingsDialogFooter;
